import { render, staticRenderFns } from "./Kardex.vue?vue&type=template&id=233a2b62"
import script from "./Kardex.vue?vue&type=script&lang=js"
export * from "./Kardex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports